import { HttpClient } from "@angular/common/http";
import {
  AfterViewInit,
  Component,
  OnInit,
  ElementRef,
  HostListener,
} from "@angular/core";
import * as $ from "jquery";
import { environment } from "src/environments/environment";
@Component({
  selector: "app-timeline",
  templateUrl: "./timeline.component.html",
  styleUrls: ["./timeline.component.scss"],
})
export class TimelineComponent implements AfterViewInit {
  animationEnabled = true;
  regli: any;
  reglist: any;
  zonli: any;
  zonlist: any;
  busli: any;
  buslist: any;
  finli: any;
  finlist: any;
  res: any;
  displayStyles = "block";

  currentPage = 0;

  rounds: any = [
    {
      title: "REGISTRATION",
    },
    {
      title: "ZONALS",
    },
    {
      title: "BUSINESS MODEL ROUND",
    },
    {
      title: "FINALE",
    },
  ];
  dataRoadmap: any = [
    {
      id: 1,
      date: "1st August to 17th September",
      title: "Registration Form Deadline",
      class: "left",
      content:
        "Eureka! opens its applications for all entrepreneurs on 1st August. Register by filling your details and logging in to the Eureka! dashboard. Add your co-founders and fill your startup idea details.",
      list: [
        {
          id: 1,
          text: "Befriending & Chat Functions",
        },
        {
          id: 2,
          text: "Challenging Feature",
        },
        {
          id: 3,
          text: "Corsair Wheel",
        },
        {
          id: 4,
          text: "Mobile Version Launch",
        },
      ],
    },
    {
      id: 2,
      date: "1st August to 17th September",
      title: "Registration Form Deadline",
      class: "right",
      content:
        "Eureka! opens its applications for all entrepreneurs on 1st August. Register by filling your details and logging in to the Eureka! dashboard. Add your co-founders and fill your startup idea details.",
      list: [
        {
          id: 1,
          text: "Befriending & Chat Functions",
        },
        {
          id: 2,
          text: "Challenging Feature",
        },
        {
          id: 3,
          text: "Corsair Wheel",
        },
        {
          id: 4,
          text: "Mobile Version Launch",
        },
      ],
    },
    {
      id: 3,
      date: "1st August to 17th September",
      title: "Registration Form Deadline",
      class: "left",
      content:
        "Eureka! opens its applications for all entrepreneurs on 1st August. Register by filling your details and logging in to the Eureka! dashboard. Add your co-founders and fill your startup idea details.",
      list: [
        {
          id: 1,
          text: "Befriending & Chat Functions",
        },
        {
          id: 2,
          text: "Challenging Feature",
        },
        {
          id: 3,
          text: "Corsair Wheel",
        },
        {
          id: 4,
          text: "Mobile Version Launch",
        },
      ],
    },
    {
      id: 4,
      date: "1st August to 17th September",
      title: "Registration Form Deadline",
      class: "right",
      content:
        "Eureka! opens its applications for all entrepreneurs on 1st August. Register by filling your details and logging in to the Eureka! dashboard. Add your co-founders and fill your startup idea details.",
      list: [
        {
          id: 1,
          text: "Befriending & Chat Functions",
        },
        {
          id: 2,
          text: "Challenging Feature",
        },
        {
          id: 3,
          text: "Corsair Wheel",
        },
        {
          id: 4,
          text: "Mobile Version Launch",
        },
      ],
    },
  ];

  dataRoadmap2: any = [
    {
      id: 1,
      date: "3st August to 17th September",
      title: "Proxy maar de aditya",
      class: "left",
      content:
        "Eureka! opens its applications for all entrepreneurs on 1st August. Register by filling your details and logging in to the Eureka! dashboard. Add your co-founders and fill your startup idea details.",
      list: [
        {
          id: 1,
          text: "Befriending & Chat Functions",
        },
        {
          id: 2,
          text: "Challenging Feature",
        },
        {
          id: 3,
          text: "Corsair Wheel",
        },
        {
          id: 4,
          text: "Mobile Version Launch",
        },
      ],
    },
    {
      id: 2,
      date: "1st August to 17th September",
      title: "Registration Form Deadline",
      class: "right",
      content:
        "Eureka! opens its applications for all entrepreneurs on 1st August. Register by filling your details and logging in to the Eureka! dashboard. Add your co-founders and fill your startup idea details.",
      list: [
        {
          id: 1,
          text: "Befriending & Chat Functions",
        },
        {
          id: 2,
          text: "Challenging Feature",
        },
        {
          id: 3,
          text: "Corsair Wheel",
        },
        {
          id: 4,
          text: "Mobile Version Launch",
        },
      ],
    },
    {
      id: 3,
      date: "1st August to 17th September",
      title: "Registration Form Deadline",
      class: "left",
      content:
        "Eureka! opens its applications for all entrepreneurs on 1st August. Register by filling your details and logging in to the Eureka! dashboard. Add your co-founders and fill your startup idea details.",
      list: [
        {
          id: 1,
          text: "Befriending & Chat Functions",
        },
        {
          id: 2,
          text: "Challenging Feature",
        },
        {
          id: 3,
          text: "Corsair Wheel",
        },
        {
          id: 4,
          text: "Mobile Version Launch",
        },
      ],
    },
    {
      id: 4,
      date: "1st August to 17th September",
      title: "Registration Form Deadline",
      class: "right",
      content:
        "Eureka! opens its applications for all entrepreneurs on 1st August. Register by filling your details and logging in to the Eureka! dashboard. Add your co-founders and fill your startup idea details.",
      list: [
        {
          id: 1,
          text: "Befriending & Chat Functions",
        },
        {
          id: 2,
          text: "Challenging Feature",
        },
        {
          id: 3,
          text: "Corsair Wheel",
        },
        {
          id: 4,
          text: "Mobile Version Launch",
        },
      ],
    },
  ];
  isVisible: any;
  constructor(private elementRef: ElementRef, private http: HttpClient) {}

  changeTabs(event: any) {
    this.currentPage = event;
  }

  // @HostListener("window:scroll", ["$event"])
  // onWindowScroll() {
  //   const scroll =
  //     window.pageYOffset ||
  //     document.documentElement.scrollTop ||
  //     document.body.scrollTop ||
  //     0;
  //   console.log(150 - scroll);
  //   $(".parallax-zoom img").css({
  //     width: `${150 - scroll / 1}%`,
  //     // top: `-${scroll / 10}%`
  //   });
  //   if (150 - scroll <= 150) {
  //     this.isVisible = true;
  //     // $('.logo').css({
  //     //   display: `block`,
  //     // })
  //   } else {
  //     this.isVisible = false;
  //     // $('.logo').css({
  //     //   display: `none`,
  //     // })
  //   }
  // }

  @HostListener("window:scroll", ["$event"])
  onWindowScroll() {
    const scroll =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    console.log(150 - scroll);

    // Only apply the scroll-related styles if the animation is not enabled
    if (!this.animationEnabled) {
      $(".parallax-zoom img").css({
        width: `${150 - scroll / 1}%`,
        // top: `-${scroll / 10}%`
      });

      if (150 - scroll <= 150) {
        this.isVisible = true;
        // $('.logo').css({
        //   display: `block`,
        // })
      } else {
        this.isVisible = false;
        // $('.logo').css({
        //   display: `none`,
        // })
      }
    }
  }

  ngOnInit(): void {
    this.displayStyles = "block";
    this.http
      .get(environment.API_URL + "getRegTimeline/")
      .subscribe((Response) => {
        this.regli = Response;
        this.reglist = this.regli.reg_time;
        this.displayStyles = "none";
      });

    this.http
      .get(environment.API_URL + "getZonTimeline/")
      .subscribe((Response) => {
        this.zonli = Response;
        this.zonlist = this.zonli.zon_time;
      });

    this.http
      .get(environment.API_URL + "getBusTimeline/")
      .subscribe((Response) => {
        this.busli = Response;
        this.buslist = this.busli.bus_time;
        console.log(this.buslist);
      });

    this.http
      .get(environment.API_URL + "getFinTimeline/")
      .subscribe((Response) => {
        this.finli = Response;
        this.finlist = this.finli.fin_time;
      });

    this.animationEnabled = true;
  }

  ngAfterViewInit(): void {
    // Initialize Bootstrap carousel
    // $(this.elementRef.nativeElement).find('.carousel').carousel();
    // Disable animation on card click
    const cards = document.querySelectorAll(".card-new");
    cards.forEach((card) => {
      card.addEventListener("click", () => {
        this.animationEnabled = false;
        card.classList.remove("card-animation");
      });
    });

    // this.onWindowScroll();
  }
}
